
const lastUpdate = '2026-03-15';
export const helpTitle = 'Audit Log Explorer';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The Audit Log Explorer records all system activity — who accessed data, who made changes, and when. Use it for compliance reviews, security investigations, or to trace a change back to its source.</p>

<h2>What Is Recorded</h2>
<ul>
  <li><strong>Reads</strong> — When a user viewed or exported a record.</li>
  <li><strong>Mutations</strong> — When a user created, updated, or deleted a record.</li>
  <li>Each entry shows the user, action type, affected feature, entity ID, and timestamp.</li>
</ul>

<h2>Filtering</h2>
<ul>
  <li><strong>User</strong> — Show activity from a specific user.</li>
  <li><strong>Action Type</strong> — Filter to reads, creates, updates, deletes, or exports.</li>
  <li><strong>Feature</strong> — Limit results to a specific module (e.g., Wildfires, Duty Log).</li>
  <li><strong>Date Range</strong> — View activity within a time window.</li>
</ul>

<h2>Exporting</h2>
<p>Click <strong>Export CSV</strong> to download audit records matching your current filters. This is suitable for compliance reporting and external review.</p>

<p><em>This tool is available to administrators only.</em></p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
